import {
	Alert,
	AutoComplete,
	Button,
	Modal,
	Col,
	Select,
	Icon,
	Input,
	Row,
	Spin,
	Table,
	Form,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPageSizeSmall } from '../utils/paging';
import styles from './lawdocument.css';
import { withRouter } from 'react-router-dom';
import {
	fetchRegisters,
	fetchLawdocuments,
	filter,
	changeOriginalFilename,
	showNewLawDocumentDialog,
	hideNewLawDocumentDialog,
	createLawDocument,
} from './lawdocumentActions';
import Highlight from '../components/highlightComponent';
import iconStyle from '../components/icon.cs';
import { formItemLayout, getRequiredRule } from '../utils/antUtils';

const { Column } = Table;
const Option = Select.Option;
const FormItem = Form.Item;

const getStringSorter = (attribute) => {
	return (a, b) => {
		return (a[attribute] || '').localeCompare(b[attribute]);
	};
};

class LawDocumentComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mergedRegisters: [], // State to hold merged registers
		};
	}

	componentDidMount() {
		// Fetch registers only if they are not already in the Redux store
		if (this.props.registers.length === 0) {
			this.props.dispatch(fetchRegisters()).then(() => {
				const mergedRegisters = this.mergeRegisters(
					this.props.registers,
					this.props.registersDefaults
				);
				this.setState({ mergedRegisters });
			});
		} else {
			// If registers are already fetched, merge with defaults
			const mergedRegisters = this.mergeRegisters(
				this.props.registers,
				this.props.registersDefaults
			);
			this.setState({ mergedRegisters });
		}

		if (this.props.list.length === 0) {
			this.props.dispatch(fetchLawdocuments(this.props.register));
		}
	}

	// Method to merge fetched registers with default registers and remove duplicates
	mergeRegisters(fetchedRegisters, defaultRegisters) {
		if (!fetchedRegisters) {
			return defaultRegisters;
		}

		const merged = [...defaultRegisters, ...fetchedRegisters];

		// Remove duplicates based on 'id'
		const uniqueRegisters = Array.from(new Map(merged.map((item) => [item.id, item])).values());
		return uniqueRegisters;
	}

	onFilter = (query) => {
		this.props.dispatch(filter(query));
	};

	onRegisterChange = (register) => {
		this.props.dispatch(fetchLawdocuments(register));
	};

	saveNewLawDocument() {
		this.props.form.validateFields((errors) => {
			if (errors) {
				return false;
			}

			this.props.dispatch(createLawDocument(this.props.originalFileName));
		});
	}

	render() {
		let data = this.props.list || [];
		const onRow = (edit) => ({
			onClick: () => {
				this.props.history.push(`/lagdel/lag/${edit.id}`);
			},
		});

		let lowerCaseFilter = this.props.filter ? this.props.filter.toLowerCase() : '';
		let compare = (a, attr) => (a[attr] || '').toLowerCase().indexOf(lowerCaseFilter) >= 0;

		data = !lowerCaseFilter
			? data
			: data.filter((lawdocument) => {
					return compare(lawdocument, 'title') || compare(lawdocument, 'sfsNumber');
			  });

		let filteredCount = data.length;

		const { getFieldDecorator } = this.props.form;

		return (
			<div>
				<Modal
					title='Skapa ny'
					visible={this.props.showNewLawDocument}
					onOk={() => this.saveNewLawDocument()}
					onCancel={() => this.props.dispatch(hideNewLawDocumentDialog())}
					width={800}
					maskClosable={false}
					okText='OK'
					cancelText='Avbryt'
				>
					{this.props.createdSblId === 0 ? (
						<Alert
							message='Produktionsbeteckning finns redan'
							type='error'
							style={{ marginBottom: 20 }}
						/>
					) : (
						''
					)}

					<Form onSubmit={this.handleSubmit}>
						<FormItem {...formItemLayout} label='Produktionsbeteckning'>
							{getFieldDecorator('originalFileName', {
								rules: [getRequiredRule('Ange en produktionsbeteckning')],
							})(
								<Input
									autoFocus
									onBlur={(e) => this.props.dispatch(changeOriginalFilename(e.target.value))}
								/>
							)}
						</FormItem>
					</Form>
				</Modal>

				<Row style={styles.toolbar}>
					<Col span={7}>
						<Select
							style={{ width: '100%' }}
							value={this.props.register}
							onChange={this.onRegisterChange}
						>
							{this.state.mergedRegisters.map((r) => (
								<Option key={r.id} value={r.id}>
									{r.name}
								</Option>
							))}
						</Select>
					</Col>
					<Col span={6}>
						<AutoComplete
							style={{ width: '100%' }}
							dataSource={[]}
							onSearch={this.onFilter}
							value={this.props.filter}
							placeholder='Filtrera på namn eller SFS...'
						>
							<Input suffix={<Icon type='search' />} />
						</AutoComplete>
					</Col>
					<Col span={2}>
						<div style={{ padding: 5 }}>
							{filteredCount} {filteredCount === 1 ? 'träff' : 'träffar'}
						</div>
					</Col>
					<Col span={9}>
						<Button
							icon='plus'
							type='primary'
							style={{ float: 'right', zIndex: 10000 }}
							size='large'
							onClick={() => this.props.dispatch(showNewLawDocumentDialog())}
						>
							Skapa ny
						</Button>
					</Col>
				</Row>

				<Spin spinning={this.props.loading}>
					<Table
						className='large-padding-table'
						dataSource={data}
						size='small'
						locale={{ emptyText: 'Inga lagdokument hittades' }}
						pagination={{ pageSize: getPageSizeSmall(), position: 'bottom' }}
						onRow={onRow}
						style={styles.table}
					>
						<Column
							title=' '
							width={15}
							render={(text) => <Icon type='book' style={iconStyle} />}
						/>

						<Column
							title='SFS #'
							width={150}
							dataIndex='sfsNumber'
							key='sfsNumber'
							sorter={getStringSorter('sfsNumber')}
							render={(text) => <Highlight text={text} query={lowerCaseFilter} />}
						/>
						<Column
							title='Namn'
							dataIndex='title'
							key='title'
							sorter={getStringSorter('title')}
							render={(text) => <Highlight text={text} query={lowerCaseFilter} />}
						/>
					</Table>
				</Spin>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		list: state.lawdocument.list,
		loading: state.lawdocument.loading,
		filter: state.lawdocument.filter,
		register: state.lawdocument.register,
		registers: state.lawdocument.registers,
		registersDefaults: state.lawdocument.registersDefaults, // Default registers from Redux store
		originalFileName: state.lawdocument.originalFileName,
		showNewLawDocument: state.lawdocument.showNewLawDocument,
		createdSblId: state.lawdocument.createdSblId,
	};
};

export default connect(mapStateToProps)(
	withRouter(
		Form.create({
			mapPropsToFields(props) {
				return {
					originalFileName: Form.createFormField({ value: props.originalFileName }),
				};
			},
		})(LawDocumentComponent)
	)
);



// WEBPACK FOOTER //
// ./src/lawdocument/lawdocumentComponent.js